import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-credibility',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTooltipModule],
  templateUrl: './credibility.component.html',
  styleUrl: './credibility.component.scss',
})
export class CredibilityComponent {
  @Input() credibility = 0;

  // CREDIBILITY
  progressCredibility = Array(10).fill(Math.random());
}
